import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Image, Col, Form, Button, Row } from "react-bootstrap";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import isEmpty from "../../../../../store/validation/is-Empty";
import { get_all_admin_active_vendors } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import { FILTER_DATE_VALUE } from "../../../../../store/types";
import { statuses } from "../../../../reusableComponents/BusinessTimingsStatus";

export const FilterAllVendorsActive = (props) => {
  const dispatch = useDispatch();
  const [dateQuery, setDateQuery] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [startAction, setAction] = useState(false);

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      dispatch(
        get_all_admin_active_vendors(
          auth.accessToken,
          true,
          dateQuery.startDate,
          dateQuery.endDate
        )
      );
      dispatch({
        type: FILTER_DATE_VALUE,
        payload: dateQuery,
      });
      setAction(false);
    }
  }, [dateQuery]);

  return (
    <React.Fragment>
      {}
      <>
        <div className="row super-admin-toptext-searchbar-icon">
          <div className="col-6">
            <div className="col-11 p-0">
              <Form.Control
                type="text"
                placeholder="Search by Business name, restaurant type, primary email,contact number,id"
                onChange={props.onChange}
                value={props.search}
                className="amSearch"
              />
            </div>
          </div>
          <div className="col-6">
            <div className="row justify-content-center align-items-center">
              <div className="col-5">
                <div className="mr-3">
                  <SelectFilter onDateChange={onDateChangeHandler} />
                </div>
              </div>
              <div className="col-3">
                <div className="d-flex align-items-center justify-content-between">
                  {props.sortMenuButton}
                  <div
                    className="f10-400"
                    align="center"
                    onClick={props.handleShowFilter}
                  >
                    <img
                      src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                      width="70px"
                    />
                    {/* <br />
                    Filter */}
                  </div>
                  {props.downloadButton}
                </div>
              </div>
            </div>
          </div>
        </div>
        {props.showFilter && (
          <div className="row">
            <div className="col-12">
              <div className="enWhiteBox mt-3">
                <Form className="row justify-content-between">
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Restaurant-type">
                          Restaurant type
                        </InputLabel>
                        <Select
                          value={props.resType}
                          onChange={props.resTypeChangeHandler}
                          label="Restaurant type"
                          inputProps={{
                            name: "Restaurant_type",
                            id: "outlined-Restaurant-type",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {props.categoryList.map((data, index) => {
                            return (
                              <MenuItem value={data} key={index}>
                                {data}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <TextField
                          variant="outlined"
                          label="Location"
                          fullWidth
                          value={props.location}
                          onChange={props.onChangeLocation}
                        />
                      </FormControl>
                    </Form.Group>
                    <Form.Group className="mb-0" controlId="formBasicCheckbox">
                      <Form.Check
                        type="checkbox"
                        label="Soft Onboarded"
                        className="f14-500"
                        onChange={props.onChangeSoftOnboarded}
                        value={props.softOnboarded}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status">
                          Status
                        </InputLabel>
                        <Select
                          value={props.statusFilter}
                          onChange={props.statusFilterHandle}
                          label="Status"
                          inputProps={{
                            name: "status",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={""}>Select Status</MenuItem>
                          {statuses.map((data, index) => {
                            return (
                              <MenuItem value={data.value} key={index}>
                                {data.title}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <div className="d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5"
                        onClick={props.handleShowFilter}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5"
                        onClick={props.handleSaveButton}
                      >
                        Search
                      </Button>
                    </div>
                  </Col>
                </Form>
              </div>
            </div>
          </div>
        )}
      </>
    </React.Fragment>
  );
};
